<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-left-pane">
      <div class="bmw-lg-videos-left-pane-nav-links">
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["home"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'),'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">home</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HOME
            </div>
          </a>
        </div>
        <!-- <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["subscription"]'
            [ngClass]="{'mini-active-link': (''|brandTypePipe) && (currentRoute==='subscription'), 'bmw-active-link': !(''|brandTypePipe) && (currentRoute==='subscription')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">video_library</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              SUBSCRIPTIONS
            </div>
          </a>
        </div> -->
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["watchlist"]'
            [ngClass]="{'mini-active-link': (APP_SETTINGS.isMINI === 'true') && (currentRoute==='watchlist'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">remove_red_eye</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              WATCHLIST
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["history"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">history</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HISTORY
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-videos-left-pane-subscriptions">
        <a href="assets/HowtoshootVideos.pdf" target="_blank">
          <div class="col-lg-1 bmw-no-gutter">
            <i class="material-icons" style="color:#1c69d4;">picture_as_pdf</i>
          </div>
          <div class="col-lg-9 bmw-no-gutter"
            style="padding-left: 15px; font-size: 12px; font-weight: bold;text-decoration:underline;color:#1c69d4;">
            How to shoot a good <br />video with your mobile phone
          </div>
        </a>
      </div>
    </div>
  </div>

  <!-- Only iPadPro and Medium size Desktop HTML5 Goes here... -->
  <div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
    <div (window:orientationchange)="screenRotate($event)">
      <div class="bmw-lg-videos-left-pane md">
        <div class="bmw-lg-videos-left-pane-nav-links">
          <div class="row bmw-no-gutter" style="margin-top: 15px">
            <a [routerLink]='["home"]'
              [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
              <div class="col-md-1 bmw-no-gutter">
                <i class="material-icons dp48">home</i>
              </div>
              <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
                HOME
              </div>
            </a>
          </div>
          <div class="row bmw-no-gutter" style="margin-top: 15px">
            <a [routerLink]='["subscription"]'
              [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription')}">
              <div class="col-md-1 bmw-no-gutter">
                <i class="material-icons dp48">video_library</i>
              </div>
              <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
                SUBSCRIPTIONS
              </div>
            </a>
          </div>
          <div class="row bmw-no-gutter" style="margin-top: 15px">
            <a [routerLink]='["watchlist"]'
              [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist')}">
              <div class="col-md-1 bmw-no-gutter">
                <i class="material-icons dp48">remove_red_eye</i>
              </div>
              <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
                WATCHLIST
              </div>
            </a>
          </div>
          <div class="row bmw-no-gutter" style="margin-top: 15px">
            <a [routerLink]='["history"]'
              [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history')}">
              <div class="col-md-1 bmw-no-gutter">
                <i class="material-icons dp48">history</i>
              </div>
              <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
                HISTORY
              </div>
            </a>
          </div>
        </div>
        <div class="bmw-lg-videos-left-pane-subscriptions">
          <a href="assets/HowtoshootVideos.pdf" target="_blank">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons" style="color:#1c69d4;">picture_as_pdf</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter"
              style="padding-left: 15px; font-size: 12px; font-weight: bold;text-decoration:underline;color:#1c69d4;">
              How to shoot a good <br />video with your mobile phone
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>


  <!--  Only Tablet or iPad HTML5 Goes here... -->
  <div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
    <div (window:orientationchange)="screenRotate($event)">
      <div class="bmw-xs-video-nav-bar flex-container row flex-align-center" 
        *ngIf='hideTopNavbar'>
        <div class="flex">
          <a [routerLink]='["home"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">home</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              HOME
            </div>
          </a>
        </div>
        <div class="flex">
          <a [routerLink]='["subscription"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">video_library</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              SUBSCRIPTIONS
            </div>
          </a>
        </div>
        <div class="flex">
          <a [routerLink]='["watchlist"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">remove_red_eye</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              WATCHLIST
            </div>
          </a>
        </div>
        <div class="flex"
          [ngClass]="{'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history'), 'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history')}">
          <a [routerLink]='["history"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">history</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              HISTORY
            </div>
          </a>
        </div>
      </div>

    </div>
  </div>

  <!-- Only Mobile hTML5 goes here... -->

  <div *ngIf='screenWidth > 319 && screenWidth < 767'>
    <div (window:orientationchange)="screenRotate($event)">
      <div class="bmw-xs-video-nav-bar flex-container row" *ngIf='hideTopNavbar'>
        <div class="flex-17">
          <a [routerLink]='["home"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">home</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              HOME
            </div>
          </a>
        </div>
        <div class="flex-30">
          <a [routerLink]='["subscription"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">video_library</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              SUBSCRIPTIONS
            </div>
          </a>
        </div>
        <div class="flex-29"
          [ngClass]="{'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist'), 'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist')}">
          <a [routerLink]='["watchlist"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">remove_red_eye</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              WATCHLIST
            </div>
          </a>
        </div>
        <div class="flex-24" >
          <a [routerLink]='["history"]'
            [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'),'rr-active-link' : (APP_SETTINGS.isRollsRoyce === 'true') && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history')}">
            <div>
              <i class="material-icons dp48" style="font-size: 20px">history</i>
            </div>
            <div class="bmw-xs-video-nav-bar-item">
              HISTORY
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>